import type { ReassignmentDetail } from '@cartwheel/api/v1'

export const REASSIGNMENT_ACTION_OPTIONS = [
  { value: 'approved', label: 'Approve reassignment' },
  { value: 'denied', label: 'Deny reassignment' },
  { value: 'assigned_to_cc', label: 'Assign to Care Coordinator' },
]

/**
 * Get available reassignment actions
 *
 * @param reassignment - The reassignment detail data from the API
 * @returns Array of action options
 */
export function getAvailableReassignmentActions(
  reassignment: ReassignmentDetail | null | undefined
): Array<{ value: string; label: string }> {
  return REASSIGNMENT_ACTION_OPTIONS
}
